<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Add new stock') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/stocks">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="saveStock">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Add product stock') }}
              </h3>
              <p class="form-description-text">{{ $t('This information will be displayed publicly') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="flex justify-between block text-sm font-medium leading-5 text-gray-700" for="product_id">
                    {{ $t('Select product') }}
                  </label>
                  <div class="mt-1 relative rounded-md shadow-sm">
                    <input-select id="product_id" v-model="product" :options="products" option-label="name" required searchable>
                      <template v-slot:selectedOption="props">
                        <template v-if="props && !props.anySelected">
                          <span class="block truncate">{{ $t('Select an option') }}</span>
                        </template>
                        <template v-else>
                          <div class="flex items-center space-x-3">
                            <div class="flex-shrink-0 inline-block">
                              <img
                                :src="props.option.avatar !== 'gravatar' ? props.option.avatar : props.option.gravatar"
                                alt="Icon"
                                class="w-5 h-auto rounded-full"
                              />
                            </div>
                            <div :class="props.option.id === product ? 'font-semibold' : 'font-normal'" class="font-normal block truncate">
                              {{ props.option.name }}
                            </div>
                          </div>
                        </template>
                      </template>
                      <template v-slot:selectOption="props">
                        <div class="flex items-center space-x-3">
                          <div class="flex-shrink-0 inline-block">
                            <img
                              :src="props.option.avatar !== 'gravatar' ? props.option.avatar : props.option.gravatar"
                              alt="Icon"
                              class="w-5 h-auto rounded-full"
                            />
                          </div>
                          <div :class="props.option.id === product ? 'font-semibold' : 'font-normal'" class="font-normal block truncate">
                            {{ props.option.name }}
                          </div>
                        </div>
                      </template>
                    </input-select>
                  </div>
                </div>
                <div class="col-span-3" v-if="attributes.length > 0">
                  <label class="form-label" for="product_attribute_id">{{ $t('Attributes') }}</label>
                  <div class="pt-1">
                    <select class="form-input" id="product_attribute_id" required v-model="stock.product_attribute_id">
                      <option disabled :value="null">{{ $t('Select an option') }}</option>
                      <option v-for="(attribute, index) in attributes" :key="index" :value="attribute.id">{{ attribute.title }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="warehouse_id">{{ $t('Warehouse') }}</label>
                  <div class="pt-1">
                    <select class="form-input" id="warehouse_id" required v-model="stock.warehouse_id">
                      <option disabled :value="null">{{ $t('Select an option') }}</option>
                      <option v-for="(warehouse, index) in warehouses" :key="index" :value="warehouse.id">{{ warehouse.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="quantity">{{ $t('Quantity') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Quantity')" class="form-input" id="quantity" required type="number" v-model="stock.quantity" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-app mr-4" to="/admin/stocks">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-green" type="submit">
                {{ $t('Save') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create new stock'),
    };
  },
  data() {
    return {
      loading: false,
      products: [],
      product: null,
      attributes: [],
      warehouses: [],
      stock: {
        product_id: null,
        product_attribute_id: null,
        warehouse_id: null,
        rack_number: null,
        quantity: 0,
      },
    };
  },

  mounted() {
    this.getStockables();
  },
  watch: {
    product: {
      handler() {
        this.stock.product_id = this.product;
        this.stock.product_attribute_id = this.$route.query.varient_id ?? null;
        const pro = this.products.find((item) => item.id === this.product);
        this.attributes = pro.has_variants ? pro.attributes : [];
      },
      deep: true,
    },
  },
  methods: {
    getStockables() {
      this.loading = true;
      axios
        .get(route('stock.list'))
        .then((response) => {
          this.loading = false;
          this.products = response.data.products;
          this.warehouses = response.data.warehouses;
          const query = this.$route.query;
          if (query.product_id) {
            this.product = Number(query.product_id);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveStock() {
      this.loading = true;
      axios
        .post(route('stocks.store'), this.stock)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          if (this.$route.query.return_url) {
            this.$router.push(
              `${this.$route.query.return_url}?open_tab=${this.$route.query.open_tab}&stock_list_id=${this.$route.query.varient_id}&stock_ref=${response.data.stock}`
            );
          } else {
            this.$router.push(`/admin/stocks/${response.data.stock}/edit`);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
